import React, { useState, useRef } from "react";
import MicroModal from "micromodal";
import { Icon } from "@iconify/react";
import useObtenerSubsecciones from "../../js/translations/useObtenerSubsecciones";
import { Link } from "react-router-dom";
import platform from "platform";
import { FocusScope } from "react-aria";

/**
 * Componente de modal para mostrar un mensaje de recomendación de navegadores.
 *
 * @component
 * @param {Object} props - Propiedades del componente.
 * @param {string} props.idModal - ID del modal.
 * @returns {JSX.Element} Elemento JSX que representa el componente.
 */
export const ModalNavegadorRecomendado = (props) => {
  const { idModal } = props;
  const { isReady, textosSubSecciones: textosHome } = useObtenerSubsecciones('home');
  const [check, setCheck] = useState(false);

  const prueba = useRef();

  const cerrarModal = () => {
    if (idModal) {
      MicroModal.close(idModal, {
        awaitCloseAnimation: true
      });
    }
  }

  const gestionarCheckboxVisibilidad = (visible) => {
    setCheck(visible)
    localStorage.setItem('modal-navegador-recomendado', JSON.stringify({
      mostrar: !visible
    }))
  }

  return (
    <>
      {isReady &&
        <FocusScope contain>
          <div className="micromodal-slide modal-navegador-recomendado" id={idModal || ''} aria-hidden="true">
            <div className="modal__overlay" data-micromodal-close>
              <div
                className="modal__container_instalacion background--bg"
                role="dialog"
                aria-modal="true"
                aria-labelledby="titulo_navegador"
                aria-describedby={'dialogo-navegador'}
              >
                <div className="d-flex flex-row-reverse">
                  <button
                    aria-label="Cerrar ventana de dialogo"
                    className="close-button onbackground-primary--color focusable-red"
                    data-micromodal-close
                    onClick={() => cerrarModal()}
                  >
                    <Icon icon={'mdi:close-thick'} width={35} />
                  </button>
                </div>
                <div className="mx-md-4">
                  <h2
                    id="titulo_navegador"
                    className={`red-inverse--color titulo-modal-navegador d-flex align-items-center justify-content-center mb-3 text-center`}
                  >
                    <img src="/img/icons/alerta.svg" className="d-none d-sm-block" aria-hidden="true" />
                    {textosHome?.modal_navegador?.titulo || 'Este navegador no es 100% compatible'}
                  </h2>
                  <p className="my-3 bold size onbackground-third--color">
                    {textosHome?.modal_navegador?.plataforma_actual?.navegador || 'Tu navegador actual:'} {`${platform?.name}, versión ${platform.version}`}
                    <br />
                    {textosHome?.modal_navegador?.plataforma_actual?.os || 'Tu sistema operativo:'} {`${platform?.os?.family} ${platform?.os?.version}`}

                  </p>
                  <p id="dialogo-navegador" className="my-3 onbackground-third--color">{textosHome?.modal_navegador?.descripcion || 'Para un perfecto funcionamiento makemake te recomienda usar los siguientes navegadores según tu sistema operativo.'}</p>

                  <img src="/img/instrucciones/navegadores-recomendados.png" className="img-fluid mx-auto" alt="Para los sistemas operativos windows, android, mac OS y Linux recomendamos el navegador google chrome versión mayor a 103. Para sistemas operativos ios recomendamos el navegador safari en su versión mayor a 11.3" />

                  <Link
                    to={'/ayuda'}
                    onClick={() => cerrarModal()}
                    className={`my-3 link-dudas text-right secondary-inverse--color d-block focusable-red`}
                  >
                    {textosHome?.modal_navegador?.enlace || '¿Tienes dudas? consulta nuestro soporte'}
                  </Link>


                  <label 
                    className="d-flex align-items-center w-100 focusable-red pointer"
                    tabIndex={0}
                    role="checkbox"
                    checked={check}
                    aria-checked={check}
                    onKeyDown={(event) => {
                      if (event.key === 'Enter') {
                        gestionarCheckboxVisibilidad(!check)
                      }
                    }}
                  >
                    <input
                      type="checkbox"
                      className="modal-checkbox"
                      ref={prueba}
                      checked={check}
                      onChange={(e) => gestionarCheckboxVisibilidad(e?.target.checked)}
                    />
                    <i className="check"></i>
                    <p className="ml-2 onbackground-primary--color">{textosHome?.modal_navegador?.check || 'No volver a mostrar'}</p>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </FocusScope>
      }

    </>
  )
}